import React from "react";
import { Controller } from 'react-hook-form';
import { Box, FilledInput, Checkbox } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckOutlined } from "@material-ui/icons";
import { configMessage } from "../../../../../../common/messages/config";


const EmailFields = (props) => {
  const { register, errors, control, watch } = props;
  const userAuthentication = watch("parameters.user_authentication");
  const { L4545 } = configMessage;
  const {
    form: { fields: fieldConst },
  } = L4545;

  return (
    <>
      <Box className={"form-input"}>
        <label>{fieldConst.email.label}</label>
        <FilledInput
          fullWidth
          type="text"
          disableUnderline
          placeholder={fieldConst.email.placeholder}
          name="parameters.email"
          onBlur={(e) => {
            e.target.value = e.target.value.trim();
          }}
          inputProps={{ maxLength: 100 }}
          inputRef={register({
            required: true,
            maxLength: 100,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: fieldConst.email.error.invalid,
            },
          })}
        />
        {errors.parameters?.email && (
          <small className="red">
            {errors.parameters?.email?.message ||
              fieldConst.email.error.required}
          </small>
        )}
      </Box>
      <Box className={"form-input"}>
        <label>{fieldConst.smtpHost.label}</label>
        <FilledInput
          fullWidth
          type="text"
          disableUnderline
          placeholder={fieldConst.smtpHost.placeholder}
          name="parameters.host"
          onBlur={(e) => {
            e.target.value = e.target.value.trim();
          }}
          inputRef={register({
            required: true,
            maxLength: {
              value: 100,
            },
            validate: (value) => !!value.trim(),
          })}
          inputProps={{ maxLength: 100 }}
        />
        {errors.parameters?.host && (
          <small className="red">{fieldConst.smtpHost.error.required}</small>
        )}
      </Box>
      <Box className={"form-input"}>
        <label>{fieldConst.smtpPort.label}</label>
        <Controller
          render={({ value, onChange }) => {
            return (
              <FilledInput
                fullWidth
                type="text"
                disableUnderline
                value={value}
                onChange={(e) => {
                  let inputVal = e.target.value.replace(/[^0-9]/g, "");
                  onChange(inputVal);
                }}
                onBlur={(e) => {
                  onChange(e.target.value.trim());
                }}
                placeholder={fieldConst.smtpPort.placeholder}
                inputProps={{ maxLength: 5 }}
              />
            );
          }}
          name="parameters.port"
          control={control}
          rules={{
            pattern: {
              value: /^([1-9]{1,4}|[0-5][0-9]{1,4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
              message: fieldConst.smtpPort.error.pattern,
            },
            validate: (value) => {
              if (!!value) {
                return !!value?.trim();
              } else {
                return false;
              }
            },
          }}
        />
        {errors.parameters?.port && (
          <small className="red">
            {errors.parameters?.port.message ||
              fieldConst.smtpPort.error.required}
          </small>
        )}
      </Box>
      <Box className={"form-input input-container"}>
        <label>{fieldConst.userAuth.label}</label>
        <Controller
          render={({ value, onChange }) => {
            return (
              <Checkbox
                className="checkbox"
                checked={!!value}
                onChange={(e) => {
                  onChange(e.target.checked);
                }}
                disableRipple
                icon={
                  <CheckBoxOutlineBlank
                    style={{
                      fontSize: 12,
                      width: 16,
                      height: 16,
                      color: "#ffffff",
                      border: "1px solid rgba(0, 0, 0, 0.13)",
                    }}
                  />
                }
                checkedIcon={
                  <CheckOutlined
                    style={{
                      fontSize: 12,
                      width: 16,
                      height: 16,
                      color: "#0062FF",
                      fontColor: "#0062FF",
                      border: "1px solid #F0F2F7",
                      backgroundColor: "#F0F2F7",
                    }}
                  />
                }
              />
            );
          }}
          name="parameters.user_authentication"
          control={control}
        ></Controller>
      </Box>
      {!!userAuthentication ? (
        <>
          <Box className={"form-input"}>
            <label>{fieldConst.username.label}</label>
            <FilledInput
              fullWidth
              type="text"
              disableUnderline
              placeholder={fieldConst.username.placeholder}
              name="parameters.username"
              inputRef={register({
                required: true,
                maxLength: {
                  value: 100,
                },
                validate: (value) => !!value.trim(),
              })}
              inputProps={{ maxLength: 100 }}
            />
            {errors.parameters?.username && (
              <small className="red">
                {fieldConst.username.error.required}
              </small>
            )}
          </Box>
          <Box className={"form-input"}>
            <label>{fieldConst.password.label}</label>
            <FilledInput
              fullWidth
              type="password"
              disableUnderline
              placeholder={fieldConst.password.placeholder}
              name="parameters.password"
              inputRef={register({
                required: true,
                maxLength: {
                  value: 100,
                },
                validate: (value) => !!value.trim(),
              })}
              inputProps={{ maxLength: 100 }}
            />
            {errors.parameters?.password && (
              <small className="red">
                {fieldConst.password.error.required}
              </small>
            )}
          </Box>
        </>
      ) : null}
    </>
  );
};

export default EmailFields;
